import { EmailAuthProvider, GoogleAuthProvider } from 'firebase/auth'
import { auth as firebaseUIAuth } from 'firebaseui'
import 'firebaseui/dist/firebaseui.css'
import { FC, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import { auth } from 'features/firebase/auth'
import { useAuthStore } from 'features/user/auth-store'

import { Card } from 'shared/components/ui/card'

export const Login: FC = () => {
  const { user, player } = useAuthStore()
  const navigate = useNavigate()

  const ref = useRef<HTMLDivElement>(null)

  if (user && player) {
    navigate('/')
  }

  useEffect(() => {
    if (!ref.current) return

    const ui = firebaseUIAuth.AuthUI.getInstance() || new firebaseUIAuth.AuthUI(auth)

    ui.start('#firebaseui-auth-container', {
      signInOptions: [
        GoogleAuthProvider.PROVIDER_ID,
        {
          provider: EmailAuthProvider.PROVIDER_ID,
          requireDisplayName: false,
          buttonColor: 'green',
        },
      ],
      signInFlow: 'popup',
    })
  }, [ref])

  return (
    <Card className="mx-auto my-10 flex w-11/12 flex-col items-center justify-center gap-2 px-2 py-4 sm:gap-6 lg:w-[800px]">
      <div className="mx-auto text-xl font-bold text-center">Login</div>
      <div ref={ref} id="firebaseui-auth-container" />
    </Card>
  )
}
